export const ACCOUNT_LIST_RESPONSE = 'ACCOUNT_LIST_RESPONSE';

export const setAccountListData = (data) => ({
  type: ACCOUNT_LIST_RESPONSE,
  data: data,
});
